var _circle, _circle2, _circle3, _circle4, _circle5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.25,
    fill: "#27A5B1",
    transform: "rotate(180 22 22)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.25,
    fill: "url(#a)",
    transform: "rotate(180 22 22)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.25,
    stroke: "url(#b)",
    strokeWidth: 1.5,
    transform: "rotate(180 22 22)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18,
    fill: "#E2FBFA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 17.25,
    stroke: "url(#c)",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.32,
    x2: 22.32,
    y1: -0.14,
    y2: 43.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1C7080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#28777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 22,
    x2: 22.74,
    y1: 4,
    y2: 40.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98E6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F7FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -17.08 21.47 0 22.32 39.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A7B4",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.8b355ae987e1584b0f1ed15ab640fb7e.svg";
export { ForwardRef as ReactComponent };